import PlayerEnvironment from 'shared/player_environment';
import { VidioHelpers } from 'shared/vidio_helpers';
import AhoyEvent from 'shared/ahoy_event';

export default class PlaybackBaseLoader {
  static init(baseUrl, baseCanaryUrl){
    this._baseUrl = baseUrl;
    this._baseCanaryUrl = baseCanaryUrl;
    this._playbackId = VidioHelpers.generateId();
  }

  static getBaseUrl(){
    return this._baseUrl;
  }

  static getBaseCanaryUrl(){
    return this._baseCanaryUrl;
  }

  static getPlaybackId(){
    return this._playbackId;
  }

  static isCanary(){
    return this.params().match(/playback-canary=true/) !== null;
  }

  static params(){
    return window.location.search;
  }

  static setup(){
    if(this.isCanary()){
      this.appendScript(this.getBaseCanaryUrl());
    } else {
      this.appendScript(this.getBaseUrl());
    }
  }

  static appendScript(scriptUrl){
    this.append(scriptUrl).then(function(){
      this.sendAhoyEvent("LOADED");
    }.bind(this)).catch(function(){
      this.sendAhoyEvent("FAILED");
    }.bind(this));
  }

  static sendAhoyEvent(name){
    var eventName = "PLAYBACK::BASE::" + name;
    AhoyEvent.send(eventName, this.properties());
  }

  static properties(){
    var property = {
      playback_uuid: PlaybackBaseLoader.getPlaybackId(),
      path: PlaybackBaseLoader.getPath(),
      revision: PlaybackBaseLoader.getRevisionTag()
    };
    return Object.assign(property, PlaybackBaseLoader.env());
  }

  static env(){
    return PlayerEnvironment.currentEnv();
  }

  static getRevisionTag(){
    if(typeof window.playback !== "undefined" && typeof window.playback.Revision !== "undefined"){
      return window.playback.Revision.tag;
    }
  }

  static getPath(){
    return window.location.pathname;
  }

  static append(src){
    return new Promise(function(resolve, reject){
      try {
        var script = document.createElement("script");
        var body   = document.getElementsByTagName("body")[0];

        script.onload = resolve;
        script.src = src;
        body.appendChild(script);

        resolve();
      } catch(e){
        reject();
      }
    });
  }

  static configure({ baseUrl, canaryBaseUrl, imaUrl, drmBlockerToggle, enableCustomSkipAdButtonToggle } = {}) {
    window.playback_feature_toggle = [];

    this.checkDrmBlocker(drmBlockerToggle);
    this.checkEnableCustomSkipAdButton(enableCustomSkipAdButtonToggle);

    this.append(imaUrl).then(() => {
      this.initThenSetup(baseUrl, canaryBaseUrl);
    }).catch(() => {
      console.error("Cannot Load imaUrl"); //jshint ignore:line
      this.initThenSetup(baseUrl, canaryBaseUrl);
    });
  }

  static checkDrmBlocker(drmBlockerToggle) {
    if (drmBlockerToggle == 'true') {
      window.playback_feature_toggle.push('drm_browser_check_on_player');
    }
  }

  static checkEnableCustomSkipAdButton(enableCustomSkipAdButtonToggle) {
    if (enableCustomSkipAdButtonToggle == 'true') {
      window.playback_feature_toggle.push('enable_custom_skip_ad_button_on_player');
    }
  }

  static initThenSetup(baseUrl, canaryBaseUrl) {
    window.playbackProperties = this.properties;
    PlaybackBaseLoader.init(baseUrl, canaryBaseUrl);
    PlaybackBaseLoader.setup();
  }
}
